
import type { SVGProps } from 'react'
const SvgWaterDrops =  (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 -960 960 960'
    {...props}
  >
    <path d='M700-800q70 62 105 114.5t35 97.5q0 60-40 104t-100 44-100-44-40-104q0-42 37-98t103-114m0 111q-27 29-43.5 56.5T640-588q0 27 17 47.5t43 20.5 43-20.5 17-47.5q0-17-16.5-44.5T700-689M480-80q-137 0-228.5-94T160-408q0-100 79.5-217.5T480-880q54 46 99 90t81 86q-7 9-25 34t-23 33q-27-32-59.5-66.5T480-774Q361-665 300.5-573T240-408q0 107 68 177.5T480-160q52 0 96-19t76-52 50-78.5 18-98.5q0-17-3.5-36T706-483q9-5 35.5-19t35.5-19q11 29 17 57.5t6 55.5q0 140-91.5 234T480-80m11-120q12-1 20.5-9.5T520-230q0-14-9-22.5t-23-7.5q-41 3-87-22.5T343-375q-2-11-10.5-18t-19.5-7q-14 0-23 10.5t-6 24.5q17 91 80 130t127 35m209-405' />
  </svg>
)
export default SvgWaterDrops
